const now = new Date()
const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
const currentMonth = new Date(now.getFullYear(), now.getMonth(), 1)

export {
	now,
	today,
	currentMonth
}
